import { render } from "./errorFaceIcon.svg?vue&type=template&id=2c3576bc"
const script = {}
script.render = render

export default script